function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#989898;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M30.91,16.964a5.982,5.982,0,1,0-5.982-5.982A5.957,5.957,0,0,0,30.91,16.964Zm-15.952,0a5.982,5.982,0,1,0-5.982-5.982A5.957,5.957,0,0,0,14.958,16.964Zm0,3.988C10.312,20.952,1,23.285,1,27.931v4.985H28.916V27.931C28.916,23.285,19.6,20.952,14.958,20.952Zm15.952,0c-.578,0-1.236.04-1.934.1,2.313,1.675,3.928,3.928,3.928,6.879v4.985H44.868V27.931C44.868,23.285,35.556,20.952,30.91,20.952Z",
  transform: "translate(-1 -5)"
});

function SvgIconPaciente(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.868,
    height: 27.916,
    viewBox: "0 0 43.868 27.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaciente);
export default __webpack_public_path__ + "static/media/icon-paciente.68532f0e.svg";
export { ForwardRef as ReactComponent };